import { left } from "@popperjs/core";
import React, { useEffect, useState } from "react";
import { OneKlicksFileSDK } from "../../../SDK/OneKlicksFileSDK";
import { debugLog } from "../../../utils/debug";
import { useAuth } from "../../../context/AuthContext";
import { getuserdata } from "../../../services/apiService";
import { Link } from "react-router-dom";
import ImageShow from "../../../Uitiles/ImageShow";
import { loginapi } from "../../../services/apiService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";


const Headercomp = ({ showsiderbar, setLogoutStatus, isMobile }) => {

    const [userdata, setUserData] = useState(
        {
            display_name: "",
            user_name: "",
            profile_photo: "",
            email: "",
            mobile_number: "",
            description: "",
            languages: [],
            memberships: [],
        }
    );
    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [isAtTop, setIsAtTop] = useState(true);  // State to track if we're at the top
    const [displayName, setDisplayName] = useState("");
    const { isLoggedIn, userData, logout, login } = useAuth();
    const [localuser, setLocaluser] = useState(null);

    const [localDoctorId, setLocalDoctorId] = useState("");

    useEffect(() => {
        getUserProfile();
        getlocaluser();
        // Function to check if we're at the top of the page
        const handleScroll = () => {
            if (window.scrollY === 0) {
                setIsAtTop(true);  // If the scroll position is at the top, set state to true
            } else {
                setIsAtTop(false);  // If scrolled down, set state to false
            }
        };

        window.addEventListener('scroll', handleScroll);  // Add scroll event listener

        const localDoctorId = localStorage.getItem("doctorId");
        setLocalDoctorId(localDoctorId);

        // Cleanup the event listener when the component is unmounted
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);  // Empty array to only run on mount and unmount

    const getlocaluser = async () => {
        const localuser = localStorage.getItem("presentuser");
        console.log("localuser getlocaluser function :", localuser);
        setLocaluser(localuser);
    }

    useEffect(() => {
        const userData = localStorage.getItem("userData");
        console.log("userData", userData.display_name);
        // Check if userData is not null or undefined before parsing
        if (userData) {
            const parsedData = JSON.parse(userData);
            setUserData(parsedData);
            setUsername(parsedData.user_name);
        }

    }, []);

    const getUserProfile = async () => {
        const displayName = await getuserdata("display_name");
        setDisplayName(displayName);
        const profilePhoto = await getuserdata("profile_photo_url");

        const profilePhotoUrl = await OneKlicksFileSDK.getfile(profilePhoto);

        debugLog("profilePhotoUrl", profilePhotoUrl);
        setUserData(
            {
                ...userdata,
                profile_photo: profilePhoto,
                profile_photo_url: profilePhoto,
            }
        );
    }

    const loginreturn = async () => {
        console.log('Attempting email login...');
        const localuser = localStorage.getItem("presentuser");
        const redirect_url = localStorage.getItem("redirect_url");
        console.log("redirect_url loginreturn function :", redirect_url);
        console.log("localuser loginreturn function :", localuser);
        const parsedData = JSON.parse(localuser);
        console.log("parsedData loginreturn function :", parsedData);
        const loginResponse = await loginapi(parsedData.email, parsedData.pass, true);
        console.log('Login response:', loginResponse);

        const user = loginResponse.data[0];

        if (user) {
            if (user.status === "2") {
                toast.error("Your account has been deleted. Please contact support.");
                return;
            }

            const userData = {
                id: user.id,
                email: user.email,
                user_type: user.user_type,
                display_name: user.display_name || user.email
            };

            console.log('User data prepared for login:', userData);
            // Use the login function from AuthContext
            const loginSuccess = await login(userData);
            console.log('Login success status:', loginSuccess);

            if (loginSuccess) {
                toast.success("Login successful!", { autoClose: 2000 });
                navigate(redirect_url);
            } else {
                console.error('Login failed - login function returned false');
                toast.error("Login failed. Please try again.");
            }
        } else {
            console.error('No user data in response');
            toast.error("Invalid credentials. Please try again.");
        }
    }
    return (
        <header id="dc-header" className={`dc-header dc-haslayout dc-header-dashboard dc-navigationarea ${isAtTop ? '' : 'sticky'}`} >
            <div className="dc-navigationarea">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                            <div className="hidpi-logowrap">
                                <strong className="dc-logo">
                                    {isMobile == true ? (
                                        <Link to="/">
                                            <img className="amsvglogo" src="//css.meddylist.com//wp-content/uploads/2025/05/Untitled-1-2.jpg" alt="MeddyList - Find Trusted Doctors &amp; Hospitals Near You" style={{ width: '42px', marginLeft: '14px', float: left }} />
                                        </Link>
                                    ) : (
                                        <Link to="/">
                                            <img className="amsvglogo" src="//css.meddylist.com//wp-content/uploads/2024/11/Untitled-1.png" alt="MeddyList - Find Trusted Doctors &amp; Hospitals Near You" />
                                        </Link>
                                    )}

                                </strong>
                                <div className="dc-rightarea">
                                    <nav id="dc-nav" className="dc-nav navbar-expand-lg">
                                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                            <i className="lnr lnr-menu"></i>
                                        </button>
                                        <div className="collapse navbar-collapse dc-navigation" id="navbarNav">
                                            <ul id="menu-header-menu" className="navbar-nav"><li className=" menu-item menu-item-type-custom menu-item-object-custom"><a href="#" className="ajax-link" data-slug="main">Home</a></li>
                                                <li className=" menu-item menu-item-type-post_type menu-item-object-page"><a href="//css.meddylist.com//search-doctors/" className="ajax-link" data-slug="search-doctors">Doctors</a></li>
                                                <li className=" menu-item menu-item-type-post_type menu-item-object-page"><a href="//css.meddylist.com//search-hospitals/" className="ajax-link" data-slug="search-hospitals">Hospitals</a></li>
                                                <li className=" menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children dropdown"><span className="dc-dropdowarrow"><i className="lnr lnr-chevron-right"></i></span><a href="#" className="ajax-link" data-slug="pharmacy-store">Pharmacy</a>
                                                    <ul className="sub-menu">
                                                        <li className=" menu-item menu-item-type-post_type menu-item-object-page"><a href="//css.meddylist.com//store-listing/" className="ajax-link" data-slug="store-listing">Pharmacy List</a></li>
                                                        <li className=" menu-item menu-item-type-post_type menu-item-object-page"><a href="//css.meddylist.com//shop/" className="ajax-link" data-slug="shop">Shop</a></li>
                                                    </ul>
                                                </li>
                                                <li className=" menu-item menu-item-type-custom menu-item-object-custom"><a href="#" className="ajax-link" data-slug="labs-digonies">Diagnostic</a></li>
                                            </ul>											</div>
                                    </nav>
                                    <ul className="add-nav shop-nav">
                                        <li className="cart-area">
                                            <div className="dc-cart dropdown">
                                                <a href="javascript:;" id="dc-cart" className="cart-contents">
                                                    <i className="fa fa-cart-plus"></i>
                                                    <span className="dc-badge">0</span>
                                                </a>

                                                <div className="dropdown-menu dc-mini-cart" aria-labelledby="dc-cart">
                                                    <div className="widget_shopping_cart_content">

                                                        <p className="woocommerce-mini-cart__empty-message">No products in the cart.</p>


                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                    <div className="dc-userlogin dc-userlogedin sp-top-menu">
                                        <figure className="dc-userimg" style={{ height: '50px', width: '50px' }}>
                                            <ImageShow url={userdata.profile_photo_url} width="50" height="50" style={{ borderRadius: '50%', height: '50px', width: '50px' }} />
                                        </figure>
                                        <div className="dc-username">
                                            <h4>{displayName}</h4>
                                        </div>
                                        <nav className="dc-usernav">
                                            <ul className="dashboard-menu-top">
                                                {localDoctorId && (
                                                    <li className="dc-active">
                                                        <Link to={`/superadmin/dashboard`}>
                                                            <i className="ti-desktop"></i>
                                                            <span>Return to Dashboard</span>
                                                        </Link>
                                                    </li>
                                                )}
                                                {localuser && (
                                                    <li className="dc-active">
                                                        <a href="#" onClick={loginreturn}>
                                                            <i className="ti-desktop"></i>
                                                            <span>Return to Dashboard</span>
                                                        </a>
                                                    </li>
                                                )}
                                                <li className="dc-active">
                                                    <a href="//css.meddylist.com//dashboard/?ref=insights&amp;identity=61">
                                                        <i className="ti-desktop"></i>
                                                        <span>Dashboard</span>
                                                    </a>
                                                </li>

                                                <li>
                                                    <a target="_blank" href="//css.meddylist.com//?post_type=doctors&amp;p=1719">
                                                        <i className="ti-eye"></i>
                                                        <span>View My Profile</span>
                                                    </a>
                                                </li>
                                                <li className="">
                                                    <a href="//css.meddylist.com//dashboard/?ref=chat&amp;identity=61">
                                                        <i className="ti-email"></i>
                                                        <span>Inbox</span>
                                                    </a>
                                                </li>
                                                <li className="">
                                                    <a href="//css.meddylist.com//dashboard/?ref=profile&amp;mode=settings&amp;identity=61">
                                                        <i className="ti-settings"></i>
                                                        <span>Profile Settings</span>
                                                    </a>
                                                </li>
                                                <li className="">
                                                    <a href="//css.meddylist.com//dashboard/?ref=specialities&amp;identity=61">
                                                        <i className="ti-notepad"></i>
                                                        <span>Specialities &amp; Services</span>
                                                    </a>
                                                </li>
                                                <li className="">
                                                    <a href="//css.meddylist.com//dashboard/?ref=account-settings&amp;mode=manage&amp;identity=61">
                                                        <i className="ti-panel"></i>
                                                        <span>Account Settings</span>
                                                    </a>
                                                </li>
                                                <li className="">
                                                    <a href="//css.meddylist.com//dashboard/?ref=appointment&amp;mode=listing&amp;identity=61">
                                                        <i className="lnr lnr-clock"></i>
                                                        <span>Appointment List</span>
                                                    </a>
                                                </li>
                                                <li className="">
                                                    <a href="//css.meddylist.com//dashboard/?ref=appointment&amp;mode=setting&amp;identity=61">
                                                        <i className="ti-clipboard"></i>
                                                        <span>Appointment Settings</span>
                                                    </a>
                                                </li>
                                                <li className="">
                                                    <a href="//css.meddylist.com//dashboard/?ref=manage-article&amp;mode=listings&amp;identity=61">
                                                        <i className="ti-pencil-alt"></i>
                                                        <span>Manage article</span>
                                                    </a>
                                                </li>
                                                <li className="">
                                                    <a href="//css.meddylist.com//dashboard/?ref=payouts&amp;mode=settings&amp;identity=61">
                                                        <i className="ti-credit-card"></i>
                                                        <span>Payouts Settings</span>
                                                    </a>
                                                </li>
                                                <li className="">
                                                    <a href="//css.meddylist.com//dashboard/?ref=saved&amp;identity=61">
                                                        <i className="ti-heart"></i>
                                                        <span>My Saved Items</span>
                                                    </a>
                                                </li>
                                                <li className="">
                                                    <a href="//css.meddylist.com//dashboard/?ref=package&amp;identity=61">
                                                        <i className="ti-package"></i>
                                                        <span>Packages</span>
                                                    </a>
                                                </li>
                                                <li className="">
                                                    <a href="//css.meddylist.com//dashboard/?ref=invoices&amp;identity=61">
                                                        <i className="ti-file"></i>
                                                        <span>Invoices</span>
                                                    </a>
                                                </li>
                                                <li><a href="#" onClick={logout}><i className="ti-shift-right"></i> <span>Logout</span></a></li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Headercomp;
